import React from "react";

export default function LongArrow({
  width,
  height,
  color,
  ...rest
}: {
  width: number;
  height: number;
  color: string;
  [x: string]: any;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.6001 0C15.821 0 16.0001 0.179086 16.0001 0.4V5.10252C16.0001 5.46012 15.5667 5.63802 15.3154 5.38356L14.0186 4.07014C13.862 3.91152 13.606 3.91152 13.4494 4.07014L7.24663 10.3524C7.09002 10.5111 6.83396 10.5111 6.67735 10.3524L5.17063 8.82639C5.01401 8.66777 4.75796 8.66777 4.60135 8.82639L1.75259 11.7117C1.59598 11.8703 1.33993 11.8703 1.18331 11.7117L0.27747 10.7942C0.123656 10.6384 0.123656 10.3879 0.27747 10.2322L4.60135 5.85281C4.75796 5.69418 5.01401 5.69418 5.17063 5.85281L6.67735 7.37886C6.83397 7.53748 7.09002 7.53748 7.24663 7.37886L11.9886 2.57609C12.1424 2.4203 12.1424 2.16981 11.9886 2.01402L10.6725 0.681034C10.423 0.428321 10.602 0 10.9571 0H15.6001Z"
        fill={color}
      />
    </svg>
  );
}
